<template>
  <div>
    <div v-if="detail.en">
      <BoardDetail :detail="detail" />
    </div>
    <div v-else>
      <v-card class="elevation-0">
        <v-card-title class="container">
          <v-spacer></v-spacer>
          <h2 class="mx-auto">برد ها</h2>
          <v-spacer></v-spacer>
          <v-btn class="elevation-0" @click="showCreate=true">
            <v-icon small>mdi-plus</v-icon>
            <div >افزودن</div>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
              hide-default-footer
              :headers="headers"
              :items="boards"
              :loading="loadingBoards"
              loading-text="در حال دریافت اطلاعات ..."
              no-data-text="بردی پیدا نشد!"
              class="elevation-0"
          >
            <template v-slot:item.name="{ item }">
              <span :class="item.is_online ? 'text-success' : 'text-danger'">
                {{ item.name }}
              </span>
            </template>
            <template v-slot:item.detail_degree="{ item }">
              <v-btn class="elevation-0" color="primary" large @click="showDetail(item, type='degree')">
                مشاهده نمودار
                <v-icon class="mr-3">mdi-poll</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.detail_report="{ item }">
              <v-btn class="elevation-0" color="primary" large @click="showDetail(item, type='report')">
                مشاهده تاریخچه
                <v-icon class="mr-3">mdi-poll</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn-toggle outline class="my-5 elevation-0 rounded-pill">
                <v-btn class="elevation-0" text color="red" @click="removeBoardView(item)">
                  <v-icon large color="red">mdi-delete</v-icon>
                </v-btn>
                <v-btn class="elevation-0" text color="primary" @click="showUpdate(item)">
                  <v-icon large color="primary">mdi-tune</v-icon>
                </v-btn>
              </v-btn-toggle>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="removeView.dialog" persistent max-width="500" class="br-1em">
        <v-card class="br-1em">
          <v-card-title>
            <h3 class="mx-auto">آیا میخواهید این برد را حذف کنید؟</h3>
          </v-card-title>
          <v-card-actions class="text-center pb-5">
            <v-spacer></v-spacer>
            <v-btn color="green" @click="cancelRemove" large text class="elevation-0">
              بازگشت
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                class="elevation-0"
                :loading="removeView.loading"
                :disabled="removeView.loading"
                @click="removeBoard(removeView.board.id)"
            >
              حذف
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <board-create @close="showCreate=false;getBoards()" :showCreate="showCreate"></board-create>
      <BoardUpdate  @close="update.en=false;getBoards()" :en="update.en" :board="update.board"></BoardUpdate>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BoardDetail from "./detail.vue";
import BoardCreate from "./create.vue";
import BoardUpdate from "./update.vue";

export default {
  name: "boardsList",
  components: {
    BoardDetail,
    BoardCreate,
    BoardUpdate
  },
  data: () => ({
    key: localStorage.getItem("key"),
    showCreate:false,
    boards: [],
    detail: {
      board: {},
      en: false,
      devices: [],
    },
    update:{
      en: false,
      board:{},
    },
    loadingBoards: true,
    headers: [
      { text: "ردیف", align: "center", value: "id" },
      { text: "نام برد", align: "center", value: "name", sortable: false },
      { text: "کد برد", align: "center", value: "code", sortable: false },
      { text: "مشاهده نمودار ها", align: "center", value: "detail_degree", sortable: false },
      { text: "مشاهده تاریخه", align: "center", value: "detail_report", sortable: false },
      { text: "حذف / ویرایش", align: "center", value: "actions", sortable: false },
    ],
    removeView: {
      dialog: false,
      loading: false,
      board: null,
    },
  }),
  created() {
    this.getBoards();
  },
  methods: {
    showUpdate(board){
      board.devices.push({name:null,code:null});
      board.sets.push({name:null, value:null});
      this.update = {
        en: true,
        board: board
      }
    },
    removeBoard(id) {
      this.removeView.loading = true;
      axios
          .delete(`${this.BACKEND_LINK}/api/devices-data/detail/${id}`, {
            headers: { Authorization: `Token ${this.key}` },
          })
          .then(() => {
            this.removeView.loading = false;
            this.removeView.dialog = false;
            this.$snotify.success("برد با موفقیت حذف شد.", "حذف برد");
          })
          .catch(() => {
            this.$snotify.error("خطا در حذف برد.", "حذف برد");
          })
          .finally(() => {
            this.getBoards();
          });
    },
    getBoardDevices(board) {
      this.loadingBoards = true;
      axios
          .get(`${this.BACKEND_LINK}/api/devices-data/detail/${board.id}`, {
            headers: { Authorization: `Token ${this.key}` },
          })
          .then((response) => {
            return response.data;
          })
          .catch((errors) => {
            this.$snotify.error("خطا در دریافت اطلاعات", `کد ${errors.response.code}`);
            return false;
          })
          .finally(() => {
            this.loadingBoards = false;
          });
    },
    showDetail(board, type) {
        this.detail = {
          board: board,
          en: true,
          type:type
        };
    },
    getBoards() {
      this.loadingBoards = true;
      axios
          .get(`${this.BACKEND_LINK}/api/devices-data/boards/`, {
            headers: { Authorization: `Token ${this.key}` },
          })
          .then((response) => {
            this.boards = response.data;
          })
          .catch((errors) => {
            this.$snotify.error("خطا در دریافت اطلاعات", `کد ${errors.response.code}‍‍‍`);
          })
          .finally(() => {
            this.loadingBoards = false;
          });
    },
    removeBoardView(item) {
      this.removeView.dialog = true;
      this.removeView.board = item;
    },
    cancelRemove() {
      this.removeView.dialog = false;
    },
  },
};
</script>
